module.exports = __webpack_public_path__ + "static/media/support_dashboard.6591ed82.jpg";